import { cva } from 'class-variance-authority'

import type { VariantProps } from 'class-variance-authority'

// One colour per icon, muted unless a severity asks otherwise. Inherit takes the
// surrounding text colour, for icons beside a label such as in a button
export const iconVariants = cva('', {
  variants: {
    severity: {
      inherit: '',
      muted: 'text-muted-foreground',
      default: 'text-foreground',
      primary: 'text-primary',
      'primary-foreground': 'text-primary-foreground',
      destructive: 'text-destructive',
      warning: 'text-warning',
      success: 'text-success',
      info: 'text-info'
    }
  },
  defaultVariants: {
    severity: 'muted'
  }
})

export type IconSeverity = NonNullable<VariantProps<typeof iconVariants>['severity']>
